<template>

    <form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" ref="form">

        <input type="hidden" name="stay-on-page" v-model="stayOnPage">

        <div class="row">

            <div class="col-md-6">

                <div class="form-group">
                    <label for="password">{{ t.__('Hasło') }}</label>
                    <input type="password" class="form-control" id="password" v-model="form.password">
                    <span class="error mt-2 text-danger" v-if="form.errors.has('password')" v-text="form.errors.get('password')"></span>
                </div>

                <div class="form-group">
                    <label for="password_confirmation">{{ t.__('Potwierdź hasło') }}</label>
                    <input type="password" class="form-control" id="password_confirmation" v-model="form.password_confirmation">
                    <span class="error mt-2 text-danger" v-if="form.errors.has('password_confirmation')" v-text="form.errors.get('password_confirmation')"></span>
                </div>

            </div>

            <div class="col-md-6" v-if="userHasPermission('user_api.user_api.show')">

                <div class="form-group">
                    <label for="api_token">{{ t.__('Token API') }}</label>
                    <input type="text" class="form-control" id="api_token" :value="token" readonly>
                    <small>{{ t.__('Ze względów bezpieczeństwa token jest widoczny tylko po wygenerowaniu') }}</small>
                    <br>
                    <a href="javascript:void(0);" class="btn btn-primary btn-sm mt-2" @click="generateApiToken()">{{ t.__('Generuj nowy') }}</a>
                </div>

                <p>{{ t.__('W celu poprawnej autoryzacji podczas połączenia z API, należy umieścić wygenerowany powyżej token w nagłówku Authorization') }}</p>
                <pre>Authorization: Bearer [{{ t.__('twój token') }}]</pre>
                <p>{{ t.__('Dodatkowo należy dołączyć poniższy nagłówek') }}</p>
                <pre>Accept: application/json</pre>

                <br>

                <h5>{{ t.__('Dostępne zasoby') }}</h5>

                <br>

                <p>1. {{ t.__('Pobierz listę maszyn') }}</p>
                <pre class="mb-0">GET https://ifpanel.net/api/machine/machines/list</pre>

                <br>

                <p>2. {{ t.__('Pobierz szczegóły maszyny') }}</p>
                <pre class="mb-0">GET https://ifpanel.net/api/machine/machines/details?[id=... serial_number=... hostname=... ip=... mac=... sim_code=...]</pre>
                <small>{{ t.__('Wymagany przynajmniej jeden z parametrów') }}</small>

                <br>

                <p class="mt-4">3. {{ t.__('Aktualizuj właściwości maszyny') }}</p>
                <pre class="mb-0">PUT https://ifpanel.net/api/machine/machines/update-details?[id=... serial_number=... hostname=... ip=... mac=... sim_code=...]</pre>
                <small>{{ t.__('Wymagany przynajmniej jeden z parametrów') }}</small>
                <p class="mt-3 mb-0">{{ t.__('Dane zapytania') }}:</p>
                <ul>
                    <li><b>name</b> <i>string</i> | {{ t.__('wymagane, dopuszczalne puste') }}</li>
                    <li><b>notes</b> <i>string</i> | {{ t.__('wymagane, dopuszczalne puste') }}</li>
                    <li><b>repo</b> <i>string/select</i> ({{ t.__('wybór jednego z dostępnych repozytoriów dla wybranej maszyny, np. [dev, test, prod]') }}) | {{ t.__('wymagane, nie puste') }}</li>
                    <li><b>autoupdate</b> <i>boolean</i> | {{ t.__('wymagane, nie puste') }}</li>
                    <li><b>language</b> <i>string/select</i> ({{ t.__('dwuznakowy kod języka, pisany małymi literami, np. [pl, en, nl ... ]') }}) | {{ t.__('wymagane, nie puste') }}</li>
                    <li><b>timezone</b> <i>string/select</i> ({{ t.__('strefa czasowa w formacie Region/Miasto, np. [Europe/Warsaw, Europe/London, Europe/Amsterdam ... ]') }}) | {{ t.__('wymagane, nie puste') }}</li>
                </ul>

            </div>

        </div>

    </form>

</template>

<script>

    export default {

        name: 'AccountForm',

        props: [
            'user'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                form: new Vue.prototype.Form({
                    password: '',
                    password_confirmation: ''
                }),
                token: null,
                stayOnPage: true
            }
        },

        beforeMount() {

            if (this.user.api_token !== null) {
                this.token = '*'.repeat(80);
            } else {
                this.token = t.__('Nie został jeszcze wygenerowany');
            }

        },

        created () {
            this.eventHub.$on('submit-form', (stay) => {
                this.stayOnPage = stay;
                this.onSubmit();
            })
        },

        beforeDestroy () {
            this.eventHub.$off('submit-form')
        },

        methods: {
            onSubmit() {
                this.form.put(route('user::account.update'))
                    .then((response) => {
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.message, 'success');
                    })
                    .catch((response) => {
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak. Sprawdź poprawność danych.'), 'error');
                    });
            },

            generateApiToken() {
                this.eventHub.$emit('processing-start');
                axios.get(route('user::account.generate-api-token'))
                    .then((response) => {
                        this.token = response.data.data.token;
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.data.message, 'success');
                    })
                    .catch((response) => {
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak. Sprawdź poprawność danych.'), 'error');
                    });
            }
        }
    }

</script>

<style scoped>

</style>
